<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { initializeKeycloak } from '@/composables/stammdatenApiComposable'
import { useEnv } from '@/composables/enviromentComposable'

const authenticated = ref<boolean>(false)
const authError = ref<string | null>(null)

const route = useRoute()
const env = useEnv()

const layout = computed(() => {
  return route.meta.layout || DefaultLayout
})

onMounted(async () => {
  if (env.AUTH_DISABLED) {
    authenticated.value = true
    return
  }

  try {
    authenticated.value = await initializeKeycloak(`${env.KEYCLOAK_REDIRECT_URI}${route.path}`)
  } catch (error) {
    console.error('Failed to initialize Keycloak:', error)
    authError.value = 'Authentifizierung konnte nicht gestartet werden.'
  }
})
</script>

<template>
  <div v-if="authenticated" class="h-screen">
    <component :is="layout">
      <RouterView />
    </component>
  </div>
  <div v-else-if="authError" class="flex h-screen items-center justify-center p-6 text-center">
    <div>
      <p class="text-lg font-semibold">{{ authError }}</p>
      <p class="mt-2">Bitte Seite neu laden oder Keycloak-Konfiguration pruefen.</p>
    </div>
  </div>
  <Toast />
  <ConfirmDialog />
</template>
